import api from "./api";

export const deleteBookingCart = async (id) => {
  return api
    .delete({
      endpoint: `/own/cart/${id}`,
      port: process.env.REACT_APP_PORT_CART,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
